import { render, staticRenderFns } from "./billplz-details.vue?vue&type=template&id=0e918427&"
import script from "./billplz-details.vue?vue&type=script&lang=js&"
export * from "./billplz-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports